// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__65Jwq","pageWrapper":"Login_pageWrapper__3T3Mp","loaderOverlay":"Login_loaderOverlay__v53v7"};